import { Component, Input, AfterViewInit } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

import * as _ from 'lodash';

@Component({
    selector: 'rules-of-policy',
    template: require('./rules-of-policy.component.html'),
    styles: [require('./rules-of-policy.component.scss')]
})
export class RulesOfPolicyComponent implements AfterViewInit {
    @Input() public processData: any;

    @Input() public get rulesSelected() {
        return this._rulesSelected;
    }

    public set rulesSelected(value) {
        this._rulesSelected = value;
    }

    @Input() public get policy() {
        return this._policy;
    }

    public set policy(value) {
        this.editModeState = false;
        if (value && value.isNew) {
            this.showSelectCheckBox = false;
            this.editModeState = true;
        } else {
            this.showSelectCheckBox = true;
        }
        this.selectAllCheckBox = false;
        this.filter = '';
        this._policy = value;
        this._policy.relationship = this.relationships
            .filter(relationship => relationship.value === this._policy.relationship.value)[0];

        this._rulesSelected = value.selectedRulesIntoOther;
        this.applyFilters();
    }

    public filter: string;
    public editModeState = false;
    public showSelectCheckBox: boolean;
    public selectAllCheckBox: boolean;

    public treeControl: FlatTreeControl<any>;
    public treeFlattener: any;
    public dataSource: any;

    public relationships = [
        { key: false, value: 'And' },
        { key: true, value: 'Or' }
    ];

    private _policy: any;
    private _rulesSelected: any[];

    constructor() {
        this.treeControl = new FlatTreeControl<any>(node => node.level, node => node.expandable);
        this.treeFlattener = new MatTreeFlattener(
            (node: any, level: number) => ({
                level,
                children: node.children,
                expandable: !!node.children && node.children.length > 0,
                item: node.item
            }),
            node => node.level,
            node => node.expandable,
            node => node.children);
        this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    }

    public ngAfterViewInit() {
        this.applyFilters();
    }

    public hasChild(_: number, node: any) {
        return node.children;
    }

    public selectAll() {
        this._rulesSelected.forEach((rule: any) => {
            rule.selected = this.selectAllCheckBox;
            rule.children.forEach((child: any) => child.selected = this.selectAllCheckBox);
        });
        this.applyFilters();
    }

    public clearFilter() {
        this.filter = '';
        this.policy.dbs = this.deepCopy(this.processData.MetaData.dbTypes);
    }

    public applyFilters() {
        let rules = this.rulesSelected.map((item: any) => {
            const node: any = { item, level: 0, expandable: false };
            node.children = item.children.map((child: any) => ({ item: child, level: 1, expandable: false }));
            return node;
        });

        if (this.showSelectCheckBox) {
            rules = rules.map((rule: any) => {
                rule.children = rule.children.filter((child: any) => child.item.selected);
                return rule;
            }).filter((rule: any) => {
                if (!rule.item.selected && rule.children.length > 0) {
                    rule.item.selected = true;
                }
                return rule.item.selected;
            });
        }

        if (this.filter && this.filter.length > 0) {
            rules = rules.filter((rule: any) => {
                const includes = (label1: string, label2: string) =>
                    label1.toUpperCase().includes(label2.toUpperCase());
                rule.children = rule.children.filter((child: any) => includes(child.item.label, this.filter));
                return includes(rule.item.label, this.filter) || rule.children.length > 0;
            });
        }

        if (this.policy.dbs) {
            rules = rules.filter((rule: any) => {
                rule.children = rule.children.filter((child: any) => {
                    return child.item.dbs && child.item.dbs.some((db: any) => {
                        return this.policy.dbs.some((x: any) => x.Key === db.Key);
                    });
                });
                return rule.children.length > 0;
            });
        }

        this.dataSource.data = rules;
    }

    public childrenAllSelected(node: any) {
        return node.children.every((child: any) => child.item.selected);
    }

    public childrenPartiallySelected(node: any) {
        node.item.selected = node.children.some((child: any) => child.item.selected);
        return node.item.selected && !this.childrenAllSelected(node);
    }

    public selectChildren(node: any) {
        node.children.forEach((child: any) => child.item.selected = node.item.selected);
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-management/policy/rules-of-policy/rules-of-policy.component.ts